import React from 'react';

import { ADMIN_WORKFLOWS } from '@ApplicationWide/permissions/constants';
import { ADMIN } from '@ApplicationWide/routes/route-groups';
import { WORKFLOWS_PATH } from '@ApplicationWide/routes/admin/admin-urls';
import { TasksIcon } from '@Generic/icons';

const ManageWorkflowsPage = React.lazy(() => import('../../../pages/Admin/ManageWorkflows'));

export default {
  label: 'navigation.workflows',
  group: ADMIN,
  to: WORKFLOWS_PATH,
  route: WORKFLOWS_PATH,
  area: ADMIN_WORKFLOWS,
  icon: <TasksIcon />,
  component: ManageWorkflowsPage,
  requiredRoles: ['admin', 'super_admin'],
  adminVisibilityPermission: ADMIN_WORKFLOWS,
  hasNavBar: true,
};
